module.exports = __webpack_public_path__ + "img/approved.3294e38c.png";